import { useEffect } from 'react';

import RoutePath from '@custom-types/RoutePath';
import { generateRoute } from '@services/navigation-service';
import { App, URLOpenListenerEvent } from '~capacitor-plugins/app';
import { Browser } from '~capacitor-plugins/browser';
import { PluginListenerHandle } from '~capacitor-plugins/core';

enum Routes {
  ResetPasswordOnsite = 'reset-password-onsite',
  OpenLogin = 'open-app/login',
}

export default function useDeeplink() {
  useEffect(() => {
    let listener: PluginListenerHandle;

    async function effect() {
      listener = await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        const url = event.url;

        if (url.includes(Routes.ResetPasswordOnsite)) {
          Browser.open({ url });
        }
        if (url.includes(Routes.OpenLogin)) {
          const params = new URLSearchParams(url.split('?')[1]);
          const token = params.get('token');
          const encodedEmail = encodeURIComponent(params.get('email') ?? '');
          window.open(
            `${generateRoute(RoutePath.LoginWithEmailLink)}?token=${token}&email=${encodedEmail}`,
            '_self'
          );
        }
      });
    }

    effect();
    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, []);
}
